import {
  DisplayHeading,
  Eyebrow,
  IndexNumber,
  Reveal,
} from '@/components/editorial';
import { AppImage } from '@/components/layout/app-image';
import { filmsData } from '@/lib/data';

export const Films = ({ embedded = false }: { embedded?: boolean }) => {
  return (
    <section
      id={embedded ? undefined : 'watchlist'}
      className={embedded ? 'w-full' : 'w-full scroll-mt-24 py-16 md:py-24'}
    >
      <div className="mb-10">
        {embedded && <Eyebrow className="mb-4">Watchlist</Eyebrow>}
        <DisplayHeading as="h2" size="lg" animate={!embedded}>
          Five films I keep recommending
        </DisplayHeading>
      </div>

      {/* Poster grid */}
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5 md:gap-6">
        {filmsData.map((film, i) => (
          <Reveal key={film.rank} delay={i * 0.08} direction="up">
            <a
              href={film.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col gap-3"
            >
              {/* Poster */}
              <div className="relative aspect-[2/3] w-full overflow-hidden rounded-xl shadow-md transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-xl group-active:scale-[0.98] group-active:shadow-xl">
                <AppImage
                  src={film.poster}
                  alt={`${film.title} poster`}
                  fill
                  className="object-cover"
                />

                {/* Hover overlay with note */}
                <div className="from-ink/90 via-ink/40 absolute inset-0 flex flex-col justify-end bg-gradient-to-t to-transparent p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="text-paper/90 text-xs leading-snug">
                    {film.note}
                  </p>
                </div>

                {/* Rank badge */}
                <div className="absolute left-2 top-2">
                  <span className="bg-background/80 rounded px-1.5 py-0.5 backdrop-blur-sm">
                    <IndexNumber value={film.rank} variant="inline" />
                  </span>
                </div>
              </div>

              {/* Info below poster */}
              <div className="flex flex-col gap-0.5">
                <h3 className="font-display text-ink group-hover:text-brand text-sm font-semibold leading-snug transition-colors">
                  {film.title}
                </h3>
                <p className="text-muted-foreground font-mono text-xs">
                  {film.director} · {film.year}
                </p>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
